// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyFetchSegmentsResult = objectOf({
  segments: arrayOf(
    objectOf({
      id: string,
      name: string,
      sync_status: string,
    })
  ),
});
